import { Position } from "@/components/Svg";
import CMultiSelect from "@/components/main/form/CMultiSelect";
import CSelect from "@/components/main/form/CSelect";
import firebase_app from "@/lib/firebase/configs";
import { Loader } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import {
  addDoc,
  collection,
  endAt,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAt,
} from "firebase/firestore";
import { useEffect, useState } from "react";

const ServicesInput = ({ dictionary, form }) => {
  const [services, setServices] = useState([]);
  const [search, setSearch] = useDebouncedState("", 300);
  const [loading, setLoading] = useState(false);

  const getTypes = async (search, inital = false) => {
    try {
      setLoading(true);
      const db = getFirestore(firebase_app);
      const q = inital
        ? query(
          collection(db, "CompanyServices"),
          orderBy("lowerCaseName"),
          limit(4)
        )
        : query(
          collection(db, "CompanyServices"),
          orderBy("lowerCaseName"),
          startAt(search.toLowerCase()),
          endAt(search.toLowerCase() + "\uf8ff"),
          limit(4)
        );
      const querySnapshot = await getDocs(q);
      let typesQueried = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        typesQueried.push(data?.name);
      });

      setServices(typesQueried);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTypes("", true);
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      getTypes(search);
    }
  }, [search]);

  return (
    <CMultiSelect
      searchable
      data={
        form?.values?.services?.length > 0
          ? Array.from(new Set([...form?.values?.services, ...services]))
          : services
      }
      placeholder={dictionary.services}
      className="mt-3"
      icon={<Position />}
      limit={5}
      hoverOnSearchChange={true}
      onSearchChange={(query) => {
        setSearch(query);
      }}
      filter={(value, selected, item) => {
        return (
          item.value.toLowerCase().startsWith(value.toLowerCase()) && !selected
        );
      }}
      rightSection={loading && <Loader variant="oval" size={26} />}
      {...form.getInputProps("services")}
    />
  );
};

export default ServicesInput;
